/**
 * WebsiteCTA — full-width call-to-action banner with dual buttons.
 */
import { ArrowRight, Phone } from 'lucide-react';

export default function WebsiteCTA({ config }) {
  const cta = config.cta_banner;
  if (!cta) return null;
  const primary = config.brand?.primary || '#0f4c81';
  const primaryDark = config.brand?.primary_dark || '#0a3a64';

  return (
    <section
      className="relative py-16 lg:py-20"
      style={{ background: `linear-gradient(135deg, ${primaryDark} 0%, ${primary} 100%)` }}
      data-testid="ws-cta-banner"
    >
      <div
        className="absolute inset-0 opacity-[0.10] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 70% 30%, rgba(255,255,255,0.45) 0, transparent 50%)',
        }}
      />
      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-black tracking-tight text-white">{cta.headline}</h2>
        {cta.body && (
          <p className="mt-4 text-base lg:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            {cta.body}
          </p>
        )}
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          {cta.primary && (
            <a
              href={cta.primary.href}
              className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-900 font-bold px-7 py-3.5 rounded-full text-sm shadow-lg shadow-black/10 transition-all"
              data-testid="ws-cta-primary"
            >
              {cta.primary.label} <ArrowRight size={16} />
            </a>
          )}
          {cta.secondary && (
            <a
              href={cta.secondary.href}
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold border border-white/30 px-7 py-3.5 rounded-full text-sm backdrop-blur-sm transition-all"
              data-testid="ws-cta-secondary"
            >
              <Phone size={16} /> {cta.secondary.label}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
